import { SUPPORTED_LANGUAGES } from "@common/constants";

export function getCookie(cname: string): string | null {
	const name = cname + "=";
	const ca = decodeURIComponent(document.cookie).split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === " ") c = c.substring(1);
		if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
	}
	return null;
}

export function getCurrentCulture(): string {
	// TODO: is this the best way to get current culture ?
	const culture = window.location.pathname.split("/")[1];
	return (
		SUPPORTED_LANGUAGES.find(
			(s) => s.key === culture || s.keyLong === culture
		)?.key ||
		getCookie("lng") ||
		WEBPACK_DEFAULT_CULTURE
	);
}

export function getCurrentLanguage(): string {
	const culture = getCurrentCulture(); // short
	return (
		SUPPORTED_LANGUAGES.find((s) => s.key === culture)?.keyLong ||
		SUPPORTED_LANGUAGES[0].keyLong
	);
}
